<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <!-- <gSwiper /> -->
    <!-- <gSite /> -->
    <div class="gContent" :style="{minHeight: (bodyHeight - 256) + 'px'}">
      <router-view></router-view>
    </div>
    <!-- <gBottom /> -->
    <gBackTop />
  </div>
</template>

<script>
import gSwiper from "@components2/gSwiper/gSwiper.vue";
//  import gSite from "@components2/En/gSite/gSite.vue";
// import gBottom from "@components2/En/gBottom/gBottom.vue";
import gBackTop from "@components2/gBackTop/gBackTop.vue";

export default {
  name: "home",
  data () {
    return {
      bodyHeight: "800px"
    };
  },
  created () {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
    document.title = "Higher Education Expo China ";
  },
  components: {
    gSwiper,
    // gSite,
    // gBottom,
    gBackTop,
  },
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.home {
  background: #f5f5f5;
}
.gContent {
  background: #f5f5f5;
  width: 1200px;
  margin: 0 auto 0;
}
</style>
